module.exports = __webpack_public_path__ + "img/logo-sm-light.69aba05d.png";